import styled from 'styled-components';

import img from './img/logo.svg';

export const StyledLogoText = styled.span`
  display: none;
`;

export const StyledLogoLink = styled.a`
  border: 0;
  display: inline-block;
  text-decoration: none;
  max-width: 120px;
  width: 100%;
  height: 38px;
  background: url(${img}) 50% 50% no-repeat;

  @media (min-width: ${props => props.theme.screen.sm}) {
    max-width: 235px;
    width: 100%;
  }

  @media (min-width: ${props => props.theme.screen.md}) {
    padding-top: 10px;
    background-size: contain;
    width: 200px;
  }
}
`;
